import React, { useContext, useEffect } from "react"
import CerrarVentana from "./CerrarVentana";
import { clBasic, SEtiqueta, SInput, toInput, toOutput } from "./general";
import { AppContext } from "./index";

export default function CambiarFechas({ ind, x, y, setRefresh, setChange, setOpen }) {
    let { firebase } = useContext(AppContext);
    let actividad = firebase.proyectoActivo.actividades[ind];

    useEffect(() => {
        document.getElementById("CFinicio").value = actividad.inicio ? toInput(actividad.inicio) : null;
        document.getElementById("CFfinestimado").value = actividad.finEstimado ? toInput(actividad.finEstimado) : null;
    }, [actividad.inicio, actividad.finEstimado]);

    const ScambiarFecha = {
        position: "fixed",
        top: y,
        left: x,
        color: clBasic,
        background: "white",
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        borderRadius: "5px",
        padding: "5px",
        zIndex: 7
    }

    return (
        <div style={ScambiarFecha}>
            <CerrarVentana set={setOpen} />
            <div style={SEtiqueta}>Inicio:</div>
            <input
                id="CFinicio"
                type="date"
                style={SInput}
                onChange={(e) => {
                    e.persist();
                    actividad.inicio = toOutput(e.target.value);
                    setRefresh((r) => !r);
                    setChange(true)
                }}
            ></input>
            <div style={SEtiqueta}>Cierre:</div>
            <input
                id="CFfinestimado"
                type="date"
                style={SInput}
                onChange={(e) => {
                    e.persist();
                    actividad.finEstimado = toOutput(e.target.value);
                    setRefresh((r) => !r);
                    setChange(true)
                }}
            ></input>
        </div >
    )

}

